export const DEFAULT_COL_WIDTH = 200;
export const EMPTY_COL_WIDTH = 48;

export const TABLE_TYPE = 'table';
export const TABLE_ROW_TYPE = 'table_row';
export const TABLE_CELL_TYPE = 'table_cell';
export const TABLE_HEADER_CELL_TYPE = 'table_header_cell';
